<template>
  <div class="dialog-add-user-or-agent-app-wrapper">
    <el-dialog
      :title="getTitle()"
      width="80%"
      :visible="visible" @open="onDialogOpen" @close="onDialogClose">

      <el-form label-position="top"
        ref="form"
        class="form"
        :model="form">

        <el-form-item label="添加应用">
          <app-transfer ref="app-picker" :app-list="availableAppList" />
        </el-form-item>

        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onFormSubmit">确定</el-button>
          <el-button @click="onFormCancel">取消</el-button>
        </el-form-item>

      </el-form>

    </el-dialog>
  </div>
</template>

<script>
import AppTransfer from './AppTransfer'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'DialogAddUserOrAgentAppWrapper',
  components: {
    AppTransfer
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    owner: {
      type: Object,
      required: true
    },
    ownerType: {
      type: String,
      required: true
    },
    // 用户/代理商已拥有的应用列表
    existedOwnerAppList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      form: {
      },

      availableAppList: []
    }
  },
  computed: {
    ...mapState('store', [
      'appList'
    ])
  },
  methods: {
    ...mapActions('store', [
      'getApps',
      'addUserApp',
      'addAgentApp'
    ]),

    getTitle () {
      if (this.ownerType === 'user') {
        return `添加用户应用 (${this.owner.username} - ${this.owner.userid})`
      } else {
        return `添加代理商应用 (${this.owner.agentname} - ${this.owner.agentid})`
      }
    },

    // 获取用户/代理商已有的应用 id 列表
    getExistedOwnerAppIdList () {
      const idList = []
      this.existedOwnerAppList.forEach(ownerApp => {
        idList.push(ownerApp.app_store_id)
      })
      return idList
    },

    async onFormSubmit () {
      try {
        const pickedApp = this.$refs['app-picker'].getPickedApps()

        if (this.ownerType === 'user') {
          await this.addUserApp({
            userid: this.owner.userid,
            app: pickedApp
          })

          this.$message({
            type: 'success',
            message: '添加商户应用成功'
          })
        } else {
          await this.addAgentApp({
            agentid: this.owner.agentid,
            app: pickedApp
          })

          this.$message({
            type: 'success',
            message: '添加代理商应用成功'
          })
        }

        this.$emit('update:visible', false)
        this.$emit('data-change')
      } catch (err) {
        console.log(err)
        // 字段检验错误直接跳过后面的检查
        if (err.code && err.code === -1) {
          return
        }

        const owner = this.ownerType === 'user' ? '商户' : '代理商'
        this.$message({
          type: 'error',
          message: `添加${owner}应用失败`
        })
      }
    },
    onFormCancel () {
      this.$emit('update:visible', false)
    },
    async onDialogOpen () {
      try {
        await this.getApps({
          page: 1,
          pageSize: 9999,
          condition: {
            app_type: this.ownerType
          }
        })

        // 遍历应用列表，删除用户/代理商已有的应用
        this.availableAppList.splice(0, this.availableAppList.length)
        const existedOwnerAppIdList = this.getExistedOwnerAppIdList()
        this.appList.forEach(app => {
          if (existedOwnerAppIdList.indexOf(app.app_store_id) === -1) {
            this.availableAppList.push(app)
          }
        })

        // console.log('available app list: ', this.availableAppList)
        this.$refs['app-picker'].generateOptions()
      } catch (err) {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取应用列表失败'
        })
      }
    },
    onDialogClose () {
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-add-user-or-agent-app-wrapper {

}
</style>



// WEBPACK FOOTER //
// src/pages/op/store/components/DialogAddUserOrAgentApp.vue